import { axios } from '../../../plugins/axios'
import { axios as axiosPol } from '../../../plugins/axios-pol'

export default {
  namespaced: true,

  state: {
    armasPersonal: [],
    id_arma_personal: 0,
  },

  getters: {
    getArmasPersonal: (state) => {
      return state.armasPersonal
    },

    getIdArmaPersonal: (state) => {
      return state.id_arma_personal
    },
  },

  mutations: {
    SET_ARMAS_PERSONAL: (state, armasPersonal) => {
      state.armasPersonal = armasPersonal
    },

    SET_ID_ARMA_PERSONAL(state, idArmaPersonal) {
      // console.log(idArmaPersonal)
      state.id_arma_personal = idArmaPersonal
    },

    UPDATE_ARMA_PERSONAL_STATUS: (state, armaPersonal) => {
      state.armasPersonal[state.armasPersonal.indexOf(armaPersonal.armaPersonal)].Arma.fk_idEstatus =
        armaPersonal.nuevoEstatus
    },
  },

  actions: {
    fetchArmasPersonal: async function ({ commit }, idPersonal) {
      try {
        const response = await axios.get('/PoliciaCuadrantes/Armeria/personal/' + idPersonal + '/armas')
        commit('SET_ARMAS_PERSONAL', response.data.data)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al obtener armas del personal.', { root: true })
        throw error
      }
    },

    saveArmaPersonal: async function (context, armaPersonal) {
      try {
        const response = await axiosPol.post('/armeria/api/Armeria/personal/' + armaPersonal.fk_idPersonal + '/armas', {
          fk_idArma: armaPersonal.fk_idArma,
          fk_idTipoAsignacion: armaPersonal.fk_idTipoAsignacion,
          fechaAsignado: armaPersonal.fechaAsignado,
          comentario: armaPersonal.comentario,
        })
        if (response.data.result === false) {
          throw new Error(response.data.error_message || 'Error al guardar arma del personal.')
        }
        context.commit('SET_ID_ARMA_PERSONAL', response.data.data[0].Id)
      } catch (error) {
        context.commit('SET_SNACKBAR_MESSAGE', error.message || 'Error al guardar arma del personal.', { root: true })
        throw error
      }
    },

    updateEstatusArmaPersonal: async function ({ commit }, armaPersonal) {
      if (armaPersonal.Arma.fk_idEstatus == 1) {
        var nuevoEstatus = 2
      } else {
        var nuevoEstatus = 1
      }

      try {
        await axios.put('/PoliciaCuadrantes/Armeria/armas/' + armaPersonal.Arma.idArma, {
          fk_idModelo: armaPersonal.Arma.fk_idModelo,
          fk_idClase: armaPersonal.Arma.fk_idClase,
          fk_idCalibre: armaPersonal.Arma.fk_idCalibre,
          fk_idEstatus: nuevoEstatus,
          fk_idSede: armaPersonal.Arma.fk_idSede,
          serie: armaPersonal.Arma.serie,
          folio: armaPersonal.Arma.folio,
          folioC: armaPersonal.Arma.folioC,
          folioD: armaPersonal.Arma.folioD,
          matricula: armaPersonal.Arma.matricula,
          loc: armaPersonal.Arma.loc,
          noEconomico: armaPersonal.Arma.noEconomico,
          ubicacion: armaPersonal.Arma.ubicacion,
          fechaAltaLoc: armaPersonal.Arma.fechaAltaLoc,
        })
        commit('UPDATE_ARMA_PERSONAL_STATUS', { armaPersonal: armaPersonal, nuevoEstatus: nuevoEstatus })
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al actualizar estatus del arma.', { root: true })
        throw error
      }
    },

    cancelaArmaPersonal: async function (context, armaPersonal) {
      try {
        const response = await axiosPol.put(
          '/armeria/api/Armeria/personal/' +
            armaPersonal.fk_idPersonal +
            '/armas/' +
            armaPersonal.idArmaPersonal +
            '/delete'
        )
        if (response.data.result === false) {
          throw new Error(response.data.error_message || 'Error al cancelar/desasignar el arma.')
        }
        context.commit('SET_SNACKBAR_MESSAGE', 'El arma ha sido desasignada del personal.', { root: true })
      } catch (error) {
        context.commit('SET_SNACKBAR_MESSAGE', error.message || 'Error al cancelar/desasignar el arma.', { root: true })
        throw error
      }
    },

    editArmaPersonal: async function (context, armaPersonal) {
      try {
        const response = await axiosPol.put(
          '/armeria/api/Armeria/personal/' + armaPersonal.fk_idPersonal + '/armas/' + armaPersonal.idArmaPersonal,
          {
            fk_idArma: armaPersonal.fk_idArma,
            fk_idTipoAsignacion: armaPersonal.fk_idTipoAsignacion,
            fechaAsignado: armaPersonal.fechaAsignado,
            comentario: armaPersonal.comentario,
          }
        )
        if (response.data.result === false) {
          throw new Error(response.data.error_message || 'Error al actualizar la asignación del arma.')
        }
        context.commit('SET_SNACKBAR_MESSAGE', 'La asignación del arma ha sido actualizada.', { root: true })
      } catch (error) {
        context.commit('SET_SNACKBAR_MESSAGE', error.message || 'Error al actualizar la asignación del arma.', {
          root: true,
        })
        throw error
      }
    },
  },
}
